export enum ActivityDuration {
  ThreeHoursOrLess = '3-hours',
  MoreThanThreeOrLessThanSixHours = '3-to-6-hours',
  MoreThan1Day = '1-day-or-more',
}
